import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import {
  LiveScoreType,
  QuestionType,
  groupUserPicks,
  stageType,
} from "../types/type";
import MatchSegment from "../components/segments/MatchSegment";
import LeaderBoardSegment from "../components/segments/LeaderBoardSegment";
import MyPickSegment, {
  calculateTotalPoint,
} from "../components/segments/MyPickSegment";
import Powered from "../components/Powered";
import { answerInterface } from "../components/segments/QuestionSegment";
import AuthService, {
  MyRanking,
  RankedUser,
  SubmitAnswersRequestBody,
  UserCount,
  UserInformationType,
  UserPick,
  UserPicksListResponse,
} from "../services";
import RegistrationModal from "../components/modals/RegistrationModal";
import MyPicksModal from "../components/modals/MyPicksModal";
import { MatchType } from "../components/MatchHeaderDropdown";
import moment from "moment";
import CongradulationsModal from "../components/modals/CongradulationPicks";
import LiveScoreBoardSegment from "../components/segments/LiveScoreBoardSegment";
import QuestionSegment from "../components/segments/QuestionSegment";
import Confetti from "react-confetti";
import CongradulationsSegment from "../components/segments/CongradulationSegment";
import {
  addCount,
  getRank,
  getUserData,
  storeLeaderBoard,
  storeRank,
  storeTotalPoint,
  storeUserData,
} from "../config/UserStorer";
import mixpanel, { track } from "mixpanel-browser";
import FirstTime from "../components/FirstTime";
import { shareOnMobile } from "react-mobile-share";
import { sortQuestionList } from "../components/utils";

let match = {
  match_mid: 50360,
  away_team_abbreviation: "PBKS",
  home_team_abbreviation: "SRH",
  start_time: "2023-04-09T14:00:00",
};
let userrankdata: MyRanking = {
  user_mid: 0,
  weekly_rank: 0,
  accumulated_rank: 0,
  user_count: 0,
};
let questionList: QuestionType[] = [
  {
    question_mid: 1,
    match_mid: 50359,
    benchmark_value: 1,
    question_type_name: "WINNING_TEAM",
  },
  {
    question_mid: 4,
    match_mid: 50359,
    benchmark_value: 41,
    question_type_name: "BOUNDARIES",
  },
  {
    question_mid: 2,
    match_mid: 50359,
    benchmark_value: 336,
    question_type_name: "RUNS",
  },
];

export const globalButtonTimeout = 100;
export interface myDataType {
  mamba_id: number;
  username: string;
  first_name: string;
  last_name: string;
  email: string;
  points: number;
}
const loadLastLink = (): stageType => {
  const url = window.location.href;
  const parts = url.split("=");
  if (parts.length > 1) {
    const lastUrl = parts.pop() as stageType;
    if (lastUrl === "question") {
      return "chooseMatch";
    }
    if (lastUrl === "invitation") {
      mixpanel.init("768cd80fc0cdabf1bf8167316486158f", { debug: false });
      mixpanel.track("Traffic From Invitation");
      return "chooseMatch";
    }
    return lastUrl;
  } else return "chooseMatch";
};
function MainPage() {
  const [stage, setStage] = useState<stageType>(loadLastLink());
  const [showClose, setShowClose] = useState(true);
  const [showShare, setShowShare] = useState(true);
  const [shadow, setShadow] = useState(true);
  const [userCount, setUserCount] = useState<UserCount>({
    user_count: 0,
    weekly_user_count: 0,
  });
  const [stagePage, setStagePage] = useState<JSX.Element>(<></>);
  const [showCurtain, setShowCurtain] = useState(false);
  const [availableMatches, setAvailableMatches] = useState<Array<MatchType>>();
  const [selectedMatch, setSelectedMatch] = useState<MatchType>();
  const [questions, setQuestions] = useState<Array<QuestionType>>(questionList);
  const [myData, setMyData] = useState<UserPicksListResponse>();
  const [userInformation, setUserInformation] = useState<UserInformationType>();
  const data = new AuthService();
  const [page, setPage] = useState<number>(0);
  const [answer, setAnswer] = useState<UserPick[]>();
  const [leaderBoard, setLeaderBoard] = useState<RankedUser[]>([]);
  const [token, setToken] = useState(localStorage.getItem("ajio_access_token"));
  const [myRankData, setMyRankData] = useState<MyRanking>(
    getRank() !== null ? getRank() : userrankdata
  );
  const [bufferScreenName, setBufferScreenName] =
    useState<stageType>("chooseMatch");
  const [inited, setInited] = useState(false);
  const [mixpanelInited, setMixPanelInited] = useState(false);
  const [loaderMessage, setLoaderMessage] = useState<string>("Game Loading!");

  React.useEffect(() => {
    trackItem("Page " + stage + " Loaded");
    if (inited) {
      window.addEventListener("popstate", () => {
        const params = new URL(window.location.href).searchParams;
        console.log("params", params);

        setStage(loadLastLink());
      });
    } else {
      setInited(true);
    }
  }, [stage]);

  React.useEffect(() => {
    loadUserInformation();
    if (getUserData() === null) {
      setStage("chooseMatch");
      loadUserInformation();
    }
  }, []);

  const trackItem = (eventname: string) => {
    if (getUserData() !== null)
      if (mixpanelInited) {
        mixpanel.track(eventname);
      } else {
        mixpanel.init("768cd80fc0cdabf1bf8167316486158f", { debug: false });
        setMixPanelInited(true);
        if (getUserData() !== null) {
          mixpanel.identify(getUserData().email);
        }
        mixpanel.track(eventname);
      }
    else {
      mixpanel.init("768cd80fc0cdabf1bf8167316486158f", { debug: false });
      setMixPanelInited(true);
      mixpanel.track(eventname);
    }
  };

  const loadUserInformation = async () => {
    const usercount: UserCount = await data.userCountCalculator();
    addCount(usercount);
    setUserCount(usercount);
    if (localStorage.getItem("ajio_access_token") !== null) {
      const userInformation: UserInformationType = await data.loadMyData();
      if (userInformation) {
        storeUserData(userInformation);
        mixpanel.identify(userInformation.email);
        console.log("userINformation", userInformation);
        setUserInformation(userInformation);
      }
      await data.userPoint();
    }
  };

  // modal state
  const [registrationModalVisible, setRegistrationModal] = useState(true);
  const [myPicksModalVisible, setMyPicksModalVisible] = useState(false);
  const [congradulationModalVisible, setCongradulationModalVisible] =
    useState(false);
  const [curtainMessage, setCurtainMessage] = useState(
    "Initializing Your Game"
  );
  const [loader, setLoader] = useState<{ index: number; visible: boolean }>({
    index: 0,
    visible: false,
  });
  const [bufferAnswer, setBufferAnswer] =
    useState<SubmitAnswersRequestBody | null>(null);
  const [firstTime, setFirstTime] = useState(false);
  const [curtainColor, setCurtainColor] = useState("blueviolet");
  const [leaderBoardTabActive, setLeaderBoardTabActive] = useState(2);
  const [curtain, setCurtain] = useState<number>(0);
  const [myPicksTab, setMyPicksTab] = useState<number>(1);

  useEffect(() => {
    window.history.pushState("", "", "index.html?page=" + stage);
    if (stage === "chooseMatch") {
      const loadData = async () => {
        setLoader({ index: 0, visible: true });
        if (!availableMatches || availableMatches?.length === 0) {
          let resp: Array<any> = await data.loadAvailableMatches();
          console.log("requested", resp);
          setAvailableMatches(
            resp.filter((a: MatchType) => {
              if (moment().weekday() < 6) {
                if (
                  moment(a.start_time).diff(moment(), "days") >= 1 &&
                  moment(a.start_time).diff(moment(), "days") < 1
                ) {
                  return true;
                }
              } else {
              }
              return true;
            })
          );
        }
        setLoader({ index: 0, visible: false });
      };
      loadData();
    }
    if (stage === "MyPick") {
      const loadData = async () => {
        let resp: UserPicksListResponse = await data.getUserPicksList();
        console.log("resplist", resp);
        setMyData(resp);
      };
      loadData();
    }
    if (
      stage === "LeaderBoard" ||
      stage === "liveScore" ||
      stage === "MyPick" ||
      stage === "chooseMatch"
    ) {
      const loadData = async () => {
        let resp: MyRanking = await data.loadMyRank();
        console.log(
          "resplist resplist resplist resplist resplist resplist resplist resplist resplist resplist resplist",
          resp
        );
        setMyRankData(resp);
        storeRank(resp);
      };
      loadData();
    }
    console.log("stagee", stage);
  }, [stage, token]);
  React.useEffect(() => {
    console.log("selected", selectedMatch);
    if (selectedMatch) {
      setLoaderMessage("Get Ready!");
      setStage("question");
    }
  }, [questions]);
  React.useEffect(() => {
    if (!token) trackItem("UnIdentified User");
  }, [token]);
  React.useEffect(() => {
    if (registrationModalVisible && !firstTime) {
      trackItem("Registration Screen Triggered");
    }
  }, [registrationModalVisible, firstTime]);
  useEffect(() => {
    if (token) setRegistrationModal(false);
  }, [token]);
  useEffect(() => {
    if (myData) {
    }
  }, [myData]);
  useEffect(() => {
    const handleScroll = () => {
      const threshold = 500; // Change this value as needed

      if (window.pageYOffset > threshold) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    };

    handleScroll();

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [stage]);

  React.useEffect(() => {});
  React.useEffect(() => {
    console.log("selectedMatch", selectedMatch, moment().toISOString());
  }, [selectedMatch]);
  // modal state
  const loadUserPick = async () => {
    let resp: UserPicksListResponse = await data.getUserPicksList();
    console.log("resplist", resp);
    setMyData(resp);
  };
  useEffect(() => {
    console.log("loader changed", loader);
  }, [loader]);
  useEffect(() => {
    setTimeout(() => {
      switch (stage) {
        case "chooseMatch":
          setShowClose(false);
          setCongradulationModalVisible(false);
          setStagePage(
            <MatchSegment
              launchRegistration={(stagename: stageType) => {
                setRegistrationModal(true);
                setBufferScreenName(stagename);
              }}
              loader={loader}
              amount="10,00,000"
              matches={availableMatches}
              onChooseMatch={handleChooseMatch}
              onPickClick={() => {
                setLoader({ index: 1, visible: true });
                handleOnMyPicksClick();
              }}
              onPlayed={(matc: MatchType) => {
                setSelectedMatch(matc);
                setMyPicksModalVisible(true);
              }}
              trackItem={trackItem}
              userCount={userCount}
              onLeaderBoard={() => {
                // setLoader({ index: 2, visible: true });
                handleOnLeaderBoard();
              }}
              onShare={handleShareWithFriends}
            />
          );
          break;
        case "question":
          setShowClose(true);
          selectedMatch &&
            setStagePage(
              <QuestionSegment
                setLoaderMessage={setLoaderMessage}
                match={selectedMatch}
                questions={sortQuestionList(questions)}
                onQuizEnd={handleOnQuizEnd}
                setCurtain={setCurtain}
                curtain={curtain}
              />
            );
          break;
        case "LeaderBoard":
          setShowClose(true);
          setStagePage(
            <LeaderBoardSegment
              amount="100"
              match={selectedMatch}
              setActive={setLeaderBoardTabActive}
              tabActive={leaderBoardTabActive}
              data={leaderBoard}
              myData={myRankData}
              page={page}
              setPage={setPage}
              name={
                userInformation?.first_name +
                " " +
                userInformation?.last_name.charAt(0).toUpperCase()
              }
              onReload={() => {
                loadUserPick();
                loadUserInformation();
                loadLeaderBoardData();
              }}
              goHome={() => setStage("chooseMatch")}
              onShare={handleShareWithFriends}
              onLogoClick={handleLogoClick}
              onLoad={async (active: number) => {
                let dat = await data.getLeaderBoard(
                  active == 1 ? false : true,
                  0,
                  40
                );
                return dat;
              }}
            />
          );
          break;
        case "liveScore":
          setShowClose(true);
          selectedMatch &&
            setStagePage(
              <LiveScoreBoardSegment
                matchWillStartIn={moment(
                  selectedMatch?.start_time + "Z"
                ).toISOString()}
                match={selectedMatch}
                answer={answer}
                amount={"10,00,000"}
              />
            );
          break;
        case "congradulations":
          setShowClose(true);
          selectedMatch &&
            setStagePage(
              <CongradulationsSegment
                matchWillStartIn={moment(
                  selectedMatch?.start_time + "Z"
                ).toISOString()}
                match={selectedMatch}
                answer={answer}
                amount={"10,00,000"}
                onLeaderBoard={handleOnLeaderBoard}
                onPick={handleOnMyPicksClick}
                onPlayAnother={handleOnPlayAnother}
              />
            );
          break;
        case "MyPick":
          setShowClose(true);
          myData &&
            setStagePage(
              <MyPickSegment
                data={myData}
                myData={myRankData}
                pointsRecievedWeekly={5}
                onPlay={handlePlay}
                pointsRecievedSeries={
                  userInformation?.points ? userInformation?.points : 0
                }
                // pointsRecieved={358}
                name={
                  userInformation?.first_name +
                  " " +
                  userInformation?.last_name.charAt(0).toUpperCase()
                }
                active={myPicksTab}
                setActive={handleMyPicksTabsChange}
                onShare={handleShareWithFriends}
                onLogoClick={handleLogoClick}
              />
            );
          break;
        default:
          setStagePage(<div></div>);
      }
    }, 500);
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 500);
  }, [stage, availableMatches, myData, token, loader]);

  useEffect(() => {
    if (!registrationModalVisible) {
      if (stage)
        setTimeout(() => {
          if (stage === "question") setCurtainColor("#222");
          else setCurtainColor("blueviolet");
          setCurtainMessage("Preparing your Game!");
          setShowCurtain(true);

          document.getElementById("curtain")?.classList.remove("animate");
          document.getElementById("curtain")?.classList.add("animate");
          setTimeout(() => setShowCurtain(false), 1500);
        }, 50);
    }
  }, [stage, curtain]);
  useEffect(() => {
    console.log("snd", answer);
  }, [answer]);

  const handleClose = () => {
    setCurtainMessage("Preparing Your Game!");
    setTimeout(() => {
      setStage("chooseMatch");
      setShowClose(true);
    }, 500);
  };

  const handleShare = () => {
    const loadData = async () => {
      console.log("i washere22", leaderBoardTabActive);
      setLoader({ index: 2, visible: true });

      let resp = await data.getLeaderBoard(
        leaderBoardTabActive === 2 ? false : true,
        page * 40,
        40 * page + 40
      );

      setLeaderBoard(resp.ranked_users);
      setLoader({ index: 2, visible: false });
    };
    if (stage === "LeaderBoard") {
      handleOnMyPicksClick();
    } else {
      loadData();
    }

    // if (stage === "MyPick") handleOnMyPicksClick();

    // setTimeout(() => {
    //   setShowClose(true);
    //   setStage("LeaderBoard");
    // }, globalButtonTimeout);
  };
  // useEffect(() => {
  //   if (leaderBoard) setStage("LeaderBoard");
  // }, [leaderBoard]);
  // Choose match

  useEffect(() => {
    if (stage === "question") {
      setShowShare(false);
    } else {
      setShowShare(true);
    }

    const loadData = async () => {
      console.log("i washere22");
      setLoader({ index: 2, visible: true });

      let resp = await data.getLeaderBoard(
        leaderBoardTabActive === 1 ? false : true,
        page * 40,
        40 * page + 40
      );
      storeLeaderBoard(resp.ranked_users);

      setLeaderBoard(resp.ranked_users);
      setLoader({ index: 2, visible: false });
    };
    if (stage === "LeaderBoard") loadData();
  }, [leaderBoardTabActive, stage]);
  useEffect(() => {
    loadLeaderBoardData();
  }, [page]);
  useEffect(() => {
    if (firstTime) trackItem("AJIO Splash Screen Triggered");
  }, [firstTime]);

  const handleChooseMatch = (matc: MatchType) => {
    setTimeout(() => {
      const loadData = async () => {
        let resp = await data.loadQuestions(matc?.match_mid);
        setQuestions(resp);
        setStage("question");
      };
      loadData();
      setSelectedMatch(matc);
      console.log("was selected", matc);

      setShowClose(true);
    }, globalButtonTimeout);
  };

  const handleOnMyPicksClick = () => {
    setTimeout(async () => {
      setShowClose(true);
      setLoader({ index: 1, visible: false });

      if (getUserData() !== null) {
        setStage("MyPick");
      } else {
        await loadUserInformation();
        handleOnMyPicksClick();
      }
    }, globalButtonTimeout);
  };
  const loadLeaderBoardData = async () => {
    let resp = await data.getLeaderBoard(
      leaderBoardTabActive === 1 ? false : true,
      page * 40,
      40 * page + 40
    );

    storeLeaderBoard(resp.ranked_users);
    setLeaderBoard(resp.ranked_users);
  };

  const handleRegister = (data: {
    first_name: string;
    last_name: string;
    email: string;
  }) => {};

  const handlePlay = () => {
    setStage("chooseMatch");
  };

  const handleOnQuizEnd = async (dat: answerInterface[]) => {
    setLoader({ index: 0, visible: true });
    setAvailableMatches([]);
    let ans: SubmitAnswersRequestBody = {
      question_response_list: dat,
    };
    if (localStorage.getItem("ajio_access_token") !== null) {
      setAvailableMatches([]);
      await data.submitAnswers(ans);
      setCongradulationModalVisible(true);
    } else {
      setBufferAnswer(ans);
      setRegistrationModal(true);
      trackItem("RegistrationLaunchedBySubmitting");
    }
    trackItem("Answer Submitted");
    const loadData = async () => {
      let resp: UserPicksListResponse = await data.getUserPicksList();
      console.log("resplist", resp);
      setMyData(resp);
      console.log(
        "haha",
        selectedMatch?.match_mid,
        groupUserPicks(resp.user_picks_list)
      );
      setAnswer(
        groupUserPicks(resp.user_picks_list)[selectedMatch?.match_mid || 0]
      );
    };
    loadData();
    // setStage("congradulations");

    setTimeout(() => {
      setStage("chooseMatch");
    }, 2000);
    setTimeout(() => {
      handleCongraModalClose();
    }, 3000);
    // }
  };

  const handleOnSeePics = () => {
    setTimeout(() => {
      setShowClose(true);
      setStage("MyPick");
    }, globalButtonTimeout);
  };

  const handleMyPicksTabsChange = (tab: number) => {
    setMyPicksTab(tab);
  };

  const handleNavigateToLeaderBoard = (tab: number) => {
    setLeaderBoardTabActive(tab);
    setTimeout(() => {
      setShowClose(true);
      setStage("LeaderBoard");
    }, globalButtonTimeout);
  };

  const handleOnLeaderBoard = async () => {
    setLoader({ index: 2, visible: true });

    if (getUserData() === null) await loadUserInformation();

    await loadLeaderBoardData();
    setStage("LeaderBoard");
    setLoader({ index: 2, visible: false });
  };

  const handleOnPlayAnother = () => {
    setStage("chooseMatch");
  };

  const handleCongraModalClose = () => {
    setStage("chooseMatch");
  };

  const handleLogoClick = () => {
    setStage("chooseMatch");
  };

  const handleOnPlayForTheFirstTime = () => {
    trackItem("Play Now Button Clicked");
    setFirstTime(false);
    localStorage.setItem("started", "started");
  };

  function formatNumberWithSeparator(number: number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  let text = `Join me on AJIO legends league this cricket season. Predict and win prizes worth ₹10,00,000`;

  // let text = `I'm ranked ${formatNumberWithSeparator(
  //   myRankData?.accumulated_rank
  // )} out of ${formatNumberWithSeparator(
  //   userCount?.user_count
  // )} players. Join me on AJIO Legends League to win a piece of ₹10,00,000 in prizes!`;

  const handleShareWithFriends = () => {
    trackItem("Game Shared");
    shareOnMobile({
      text: text,
      url: "http://www.ajiolegendsleague.com/index.html?page=invitation",
      title: text,
    });
  };

  return (
    <div className="mainPage">
      {false && (
        <Header
          share={showShare}
          // close={showClose}
          // shadow={shadow}
          onShare={handleShareWithFriends}
          onClose={handleClose}
          stage={stage}
        />
      )}
      {firstTime && (
        <FirstTime
          amount={"10,00,000"}
          onPlayNow={handleOnPlayForTheFirstTime}
        />
      )}

      {false && (
        <div
          id="curtain"
          className={"animate"}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: curtainColor,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            overflow: "hidden",
            zIndex: 1000,
            scale: "0px",
            opacity: 1,
            boxShadow: "0px 100px 150px #eee",
          }}
        >
          {stage === "liveScore" && (
            <Confetti
              recycle={false}
              gravity={10}
              width={window.screen.availWidth}
              height={300}
            />
          )}

          <img
            src={stage === "question" ? "loading.png" : "cricket.png"}
            style={{
              width: 200,
            }}
            alt={"loading_image"}
          />
          <h1
            style={{
              margin: 0,
              padding: "20px",
              animation: "curtain-fade-in 1.5s ease-out forwards",
              color: "white",
            }}
          >
            {stage !== "question" ? "Loading your game" : loaderMessage}
          </h1>
        </div>
      )}
      <RegistrationModal
        modalVisible={registrationModalVisible}
        setModalVisible={() => {
          setRegistrationModal(false);
        }}
        trackItem={(eventname: string) => {
          trackItem(eventname);
        }}
        onSubmit={async ({
          firstname,
          lastname,
          email,
          phone,
        }: {
          firstname: string;
          lastname: string;
          email: string;
          phone: string;
        }) => {
          let em = email.toLowerCase();
          await data.registerWithFetch(
            firstname,
            firstname,
            lastname,
            em,
            phone
          );
          setAvailableMatches([]);
          trackItem("Registration Completed");
          setCurtainMessage("WELCOME TO AJIO LEGENDS LEAGUE!");
          setCurtainColor("green");
          setShowCurtain(true);
          const tk = localStorage.getItem("ajio_access_token");
          setToken(tk);
          if (bufferAnswer !== null) {
            handleOnQuizEnd(bufferAnswer.question_response_list);
          }
          await loadUserInformation();
          setLoader({ index: 0, visible: true });
          let resp = await data.loadAvailableMatches();
          setLoader({ index: 0, visible: false });

          console.log("resp", resp);
          setAvailableMatches(resp);
          if (bufferScreenName !== "chooseMatch") setStage(bufferScreenName);
          // console.log("loaded", loaded);
        }}
      />
      {selectedMatch && (
        <MyPicksModal
          lauchRegistration={() => setRegistrationModal(true)}
          match={selectedMatch}
          modalVisible={myPicksModalVisible}
          setModalVisible={setMyPicksModalVisible}
          onSeePicks={handleOnSeePics}
          team1Logo={selectedMatch ? selectedMatch.home_team_abbreviation : ""}
          team2Logo={selectedMatch ? selectedMatch.away_team_abbreviation : ""}
        />
      )}

      <CongradulationsModal
        modalVisible={congradulationModalVisible}
        setModalVisible={setCongradulationModalVisible}
        parent
        onSeePicks={() => {
          setStage("MyPick");
          setCongradulationModalVisible(false);
        }}
        onClose={handleCongraModalClose}
      />
      <div className="flex containerMinHeight">
        <div className="pageContent">{stagePage}</div>
      </div>
      <a
        href={"https://www.mambafantasy.com"}
        target={"_blank"}
        rel={"noreferrer"}
        style={{ textDecoration: "none" }}
        onMouseOver={() => {
          trackItem("Traffic To Mamba Fantasy");
        }}
      >
        <Powered />
      </a>
    </div>
  );
}
export const formatNumber = (number: number): string => {
  let num = number.toString();
  var pattern = /(-?\d+)(\d{3})/;
  while (pattern.test(num)) {
    num = num.replace(pattern, "$1,$2");
  }
  if (num.length > 6) {
    num = num.slice(0, -6) + "," + num.slice(-6);
  }
  return num;
};

export default MainPage;
